import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Calendar, ArrowRight } from 'lucide-react';
import { fetchCollection } from '../../lib/cms';
import SEO from '../../components/SEO';

export default function KundeudtalelserDe() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    async function loadData() {
      const data = await fetchCollection('testimonials', 'de');
      setTestimonials(data);
    }
    loadData();
  }, []);

  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Kundenstimmen & Bewertungen - Danshaker"
        description="Erfahren Sie, was professionelle Reitbetriebe und Pferdehalter über den Danshaker sagen. Bis zu 50% Zeitersparnis bei der täglichen Stallarbeit."
        path="/de/kundenstimmen"
        lang="de"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Header Section */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-12 md:px-8 md:pt-24">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
            <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
            <span>Erfahrungen unserer Kunden</span>
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Kundenstimmen
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed">
            Lesen Sie die echten Praxiserfahrungen von Reitanlagen, Züchtern und Pferdehaltern, die ihren Stallalltag mit dem Danshaker spürbar erleichtert haben.
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-8">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="flex flex-col justify-between rounded-3xl border border-slate-200 bg-white p-8 shadow-xl transition hover:border-[#0E67A2]/30 hover:shadow-2xl"
            >
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  {item.image && item.image[0] ? (
                    <img
                      src={item.image[0]}
                      alt={item.name}
                      width="56"
                      height="56"
                      loading="lazy"
                      decoding="async"
                      className="h-14 w-14 rounded-full object-cover border-2 border-slate-200"
                    />
                  ) : (
                    <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#0E67A2]/10 text-[#0E67A2] font-black text-xl border-2 border-[#0E67A2]/20">
                      {item.name ? item.name.charAt(0) : 'K'}
                    </div>
                  )}
                  <div>
                    <h3 className="font-bold text-slate-900 text-lg leading-tight">{item.name}</h3>
                    <p className="text-xs text-slate-500 font-semibold">{item.company}</p>
                    <div className="flex items-center gap-1 text-amber-400 text-xs mt-1" aria-label="5 von 5 Sternen">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                    </div>
                  </div>
                </div>

                <div
                  className="text-slate-700 leading-relaxed text-sm font-medium pt-2 italic"
                  dangerouslySetInnerHTML={{ __html: item.text }}
                />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="border-t border-slate-200 bg-white py-16">
        <div className="mx-auto max-w-4xl px-4 text-center md:px-8 space-y-6">
          <h2 className="text-3xl font-extrabold text-slate-900 md:text-4xl">
            Möchten Sie selbst den Unterschied spüren?
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Buchen Sie eine kostenlose und unverbindliche Vorführung in Ihrem eigenen Stall und testen Sie den Danshaker direkt vor Ort.
          </p>
          <div className="pt-2 flex flex-wrap justify-center gap-4">
            <Link
              to="/de/kostenlose-demo"
              className="inline-flex items-center gap-2 rounded-xl bg-[#0E67A2] px-8 py-4 font-bold text-white transition hover:bg-[#0E67A2]/90 shadow-lg"
            >
              <Calendar className="h-5 w-5" />
              Kostenlose Vorführung buchen
            </Link>
            <Link
              to="/de/kontakt"
              className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-8 py-4 font-bold text-slate-800 transition hover:bg-slate-100"
            >
              Kontakt aufnehmen
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
